module.exports = __webpack_public_path__ + "static/media/prize-7.9dbd1b0f.png";